import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import {
  getFinanceDisplayPeriods,
  getFinancePaymentDashboard,
  getFinanceMonths,
  getFinancesTotal,
  getFinancesTimeRange
} from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';
import { providerQueryKeys } from './providerQueryKeys';


export const useFinancesTotalQuery = (providerId: string, opts?: BaseQueryOpts) =>
  useQuery({
    queryKey: providerQueryKeys.financesTotal(providerId),
    queryFn: async () => {
      const response = await getFinancesTotal(providerId);

      return response;
    },
    select: response => response.data,
    ...opts,
  });


export const useFinancesTimeRangeQuery = (providerId: string, opts?: BaseQueryOpts) =>
  useQuery({
    queryKey: providerQueryKeys.financesRange(providerId),
    queryFn: () => getFinancesTimeRange(providerId),
    select: response => response.data,
    ...opts,
  });


export const useFinanceMonthsQuery = (
  params: {
    providerId: string;
    rangeFrom: string;
    rangeTo: string;
  },
  opts?: BaseQueryOpts
) =>
  useInfiniteQuery({
    queryKey: providerQueryKeys.financesMonths(params.providerId, params.rangeFrom, params.rangeTo),
    queryFn: async ({ pageParam }) => {
      return await getFinanceMonths(params.providerId, {
        rangeFrom: params.rangeFrom,
        rangeTo: params.rangeTo,
        cursor: pageParam,
      });
    },
    select: data => ({
      pages: data.pages.flatMap(x => x.data),
      pageParams: data.pageParams
    }),
    getNextPageParam: (lastPage) => lastPage?.cursor,
    ...opts,
  });


export const useFinanceDisplayPeriodsQuery = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: providerQueryKeys.financesDisplayPeriod(providerId),
    queryFn: () => getFinanceDisplayPeriods(providerId),
    ...opts,
  });
};


export const useFinancePaymentDashboardQuery = (providerId: string, period: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: providerQueryKeys.financesPeriod(providerId, period),
    queryFn: () => getFinancePaymentDashboard(providerId, { current_date: period }),
    ...opts,
  });
};
